import { render, staticRenderFns } from "./VRSelect.vue?vue&type=template&id=42da0968"
import script from "./VRSelect.vue?vue&type=script&lang=js"
export * from "./VRSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports